import React from "react";
import "./style.css";
import { Tabs, Spin } from "antd";
import ActiveUsers from "./activeUsers";
import InactiveUsers from "./inactiveUsers";

const { TabPane } = Tabs;

export default class Progress extends React.Component {
  state = {
    users: [],
    activeUsers: [],
    deadUser: [],
  };

  componentDidMount = () => {
    fetch(
      "https://sbhs-web-server.herokuapp.com/lte/user/all"
      // "http://localhost:4000/lte/user/all"
    )
      .then((response) => response.json())
      .then((response) => {
        const dead = response.filter((user) => {
          return user.usertype === "Agent" && user.courseCompleted.length === 0
            ? user
            : null;
        });
        const active = response.filter((user) => {
          return user.usertype === "Agent" && user.courseCompleted.length > 0
            ? user
            : null;
        });
        this.setState({ activeUsers: active, deadUser: dead });

        // if (response) {
        //   const results = response.map((course, index) => ({
        //     _id: course._id,
        //     key: course._id,
        //     courseNumber: index + 1,
        //     name: course.name,
        //     company: course.company,
        //     password: course.password,
        //     batch: course.batch,
        //     email: course.email,
        //     usertype: course.usertype,
        //     courseCompleted: course.courseCompleted,
        //   }));
        //   this.setState({ users: results });
        // }
      });
  };

  render() {
    const { activeUsers, deadUser } = this.state;
    return (
      <div>
        {activeUsers.length === 0 || deadUser.length === 0 ? (
          <div>
            <div className="loadingText"></div>
            <div className="tc f19 lh-copy">
              <Spin />
            </div>
          </div>
        ) : (
          <Tabs defaultActiveKey="1">
            <TabPane tab="Summary" key="1">
              Charts will be added here
            </TabPane>
            <TabPane tab={"Active Agents (" + activeUsers.length + ")"} key="2">
              <ActiveUsers users={activeUsers} />
            </TabPane>
            <TabPane tab={"Dead Agents (" + deadUser.length + ")"} key="3">
              <InactiveUsers users={deadUser} />
            </TabPane>
          </Tabs>
        )}
      </div>
    );
  }
}
